import { Injectable } from '@angular/core';
import {
    Router, Resolve,
    RouterStateSnapshot,
    ActivatedRouteSnapshot
} from '@angular/router';
import { Notification } from 'rxjs';
import { NotificationService } from '../services/notification.service';

@Injectable({
    providedIn: 'root'
})
export class NotificationCenterResolver implements Resolve<any> {
    constructor(private notifcationService: NotificationService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {
        let id = route.parent.params['id'];
        console.log('NotificationCenterResolver for site ' + id);
        return this.notifcationService.getUserNotifications(id);
    }
}
